<template>
  <div id="app">
    <router-view class="router-main" v-if="show"/>
  </div>
</template>


<script>
  import { mapState } from 'vuex'
  export default{
    data() {
      return {
        show: false,
        autoHide: false
      }
    },
    beforeMount(){
      /* 初次进入 */
      let s = location.search
      if(s.match('_t=[3|4|5|6|7|8]')){
        this.$store.commit('hasLoginPage', false)
        /* 参数中有_t，认为是登录串登录 */
        this.$axios.get(`/m/login${s}`)
          .then(resp => {
            /* 进行登录请求后再渲染router */
            let data = resp.data
            if(data && data.status == 'ok'){
              console.log('登录成功')
              localStorage.setItem('__token_d', data.message.token)
              this.show = true
              this.$store.commit('changeUserId', data.message.id)
              if(data.jsessionid){
                if(window.TongAnBridge && window.TongAnBridge.setJSessionId){
                  // this.$toast(`设置jsessionid：${data.jsessionid}`, 3000)
                  /* android */
                  window.TongAnBridge.setJSessionId(data.jsessionid)
                } else {
                  if(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers['setJSessionId']){
                    /* ios */
                    window.webkit.messageHandlers['setJSessionId'].postMessage({"jid": data.jsessionid})
                  } else {
                    /* web */
                  }
                }
              }
            } else {
              this.show = true
              this.$router.push('/login')
            }
          })
          .catch(err => {
            this.$toast(`登录错误\n[${err && err.response ? err.response.status || 'Error' : 'NETWORK ERROR'}]${err && err.response && err.response.data ? err.response.data.message || '未知错误' : '网络错误'}`)
          })

      } else {
        this.$store.commit('hasLoginPage', true)
        this.show = true
      }

      let tid = this.$url.getParams()._tid || this.$url.getParams().tid
      if(tid){
        this.$axios.get(`/m/p/a/t?tid=${tid}`)
          .then(res => {
            if(res.data && res.data.status == 'ok') {
              let m = res.data.message
              this.$store.commit('setTenant', m)
              if(m.favicon){
                document.querySelector('link[rel="icon"]').href = `/m/p/a/timg/${m.id}/${m.favicon}`
              }
            } else {
              this.$store.commit('setTenant', {})
            }
          })
      } else {
        this.$store.commit('setTenant', {})
      }
    },
    computed: {
      ...mapState([
        'facerecog'
      ])
    },
    methods: {
      cancelRecognition() {
        sessionStorage.removeItem('startRecog')
				sessionStorage.removeItem('logId')
        // this.$toast('用户放弃人脸识别')
        this.$store.commit('faceRecognitionCancel')
        // console.log(this.$route.path)
        /* 仅当在考试页面与视频页面取消人脸识别时，退出到上一页 */
        if(this.$route.path == '/exam' || this.$route.path.startsWith('/class/')){
          this.$router.go(-1)
        }
      },
      startRecognition() {
        sessionStorage.setItem('startRecog', true)
        this.$router.push('/recog')
      },
    },
    watch: {
      async facerecog(val) {
        if(val){
          if(sessionStorage.getItem('allowDesktopFace')) {
            if(this.$check.cam()){
              let status = await this.$check.canVideo()
              if(status){
                this.startRecognition()
              } else {
                alert('请连接摄像头')
                /* 仅当在考试页面与视频页面取消人脸识别时，退出到上一页 */
                if(this.$route.path == '/exam' || this.$route.path.startsWith('/class/')){
                  this.$router.go(-1)
                }
              }
              // alert('当前课程已开通人脸验证，请通过手机访问学习！')
            } else {
              this.$store.commit('faceRecognitionCancel')
              alert('当前浏览器不支持摄像头采集，请更换其他浏览器')
              /* 仅当在考试页面与视频页面取消人脸识别时，退出到上一页 */
              if(this.$route.path == '/exam' || this.$route.path.startsWith('/class/')){
                this.$router.go(-1)
              }
            }
          } else {
            this.startRecognition()
          }
        }
      },
    }
  }
</script>

<style lang="scss">
  * {
    border: 0;
    padding: 0;
    margin: 0;
  }
  html, body {
    height: 100%;
  }
  body {
    background: #ECEDED;
  }
  a {
    text-decoration: none;
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    height: 100%;
    color: #333;
    font-size: 16px;
  }
</style>
